// @material-ui/icons
import Key from "@material-ui/icons/VpnKey"
import GroupIcon from "@material-ui/icons/Group";
import DrinkIcon from "@material-ui/icons/LocalDrink";
import MoneyIcon from "@material-ui/icons/MonetizationOn";
import ChartIcon from "@material-ui/icons/InsertChart";
import OrganizationIcon from "@material-ui/icons/Domain";
import ReportsIcon from "@material-ui/icons/LibraryBooks";
import LogIcon from "@material-ui/icons/Subject";
// core components/views
import InvalidKeysPage from "views/Keys/Keys";
import UsersPage from "views/Users/Users";
import MachinesPage from "views/Machines/Machines";
import MachinePage from "views/Machines/Machine";
import OrdersPage from "views/Orders/Orders";
import StatisticsPage from "views/Statistics/Statistics";
import OrganizationsPage from "views/Organizations/Organizations";
import ReportsPage from "views/Reports/Reports";
import ReprotPage from "views/Reports/Report";
import KeyPage from "views/Keys/Key";
import LogPage from "views/Logs/Logs";
import { roles } from "utils/misc";

const dashboardRoutes = [
    {
        path: "/machines",
        sidebarName: "Автоматы",
        navbarName: "Автоматы",
        icon: DrinkIcon,
        component: MachinesPage,
        exact: true,
        availableWithRoles: [roles[0], roles[1], roles[2], roles[3], roles[4]],
    },
    {
        path: "/orders",
        sidebarName: "Финансы",
        navbarName: "Продажи/Инкассации",
        icon: MoneyIcon,
        component: OrdersPage,
        availableWithRoles: [roles[0], roles[1], roles[2]],
    },
    {
        path: "/statistics",
        sidebarName: "Статистика",
        navbarName: "Статистика",
        icon: ChartIcon,
        component: StatisticsPage,
        availableWithRoles: [roles[0], roles[1], roles[2]],
    },
    {
        path: "/keys",
        sidebarName: "Ключи",
        navbarName: "Ключи",
        icon: Key,
        component: InvalidKeysPage,
        exact: true,
        availableWithRoles: [roles[0], roles[2], roles[5]],
    },
    {
        path: "/reports",
        sidebarName: "Заявки",
        navbarName: "Заявки",
        icon: ReportsIcon,
        component: ReportsPage,
        exact: true,
        availableWithRoles: [roles[0], roles[3]],
    },
    {
        path: "/organizations",
        sidebarName: "Организации",
        navbarName: "Организации",
        icon: OrganizationIcon,
        component: OrganizationsPage,
        availableWithRoles: [roles[0]],
        availableWithMasterOrganization: true,
    },
    {
        path: "/users",
        sidebarName: "Пользователи",
        navbarName: "Пользователи",
        icon: GroupIcon,
        component: UsersPage,
        availableWithRoles: [roles[0]],
  },
    {
        path: "/logs",
        sidebarName: "Логи",
        navbarName: "Логи",
        icon: LogIcon,
        component: LogPage,
        availableWithRoles: [roles[0]],
        availableWithMasterOrganization: true,
    },
    {
        path: "/machines/:id",
        component: MachinePage,
        sidebarHidden: true,
        navbarName: "Автомат",
        parentPath: "/machines",
        availableWithRoles: ["*"],
    },
    {
        path: "/reports/:id",
        component: ReprotPage,
        sidebarHidden: true,
        navbarName: "Заявка",
        parentPath: "/reports",
        availableWithRoles: [roles[0], roles[3]],
    },
    {
        path: "/keys/:id",
        component: KeyPage,
        sidebarHidden: true,
        navbarName: "Ключ",
        parentPath: "/keys",
        availableWithRoles: [roles[0], roles[2], roles[2]],
    },
    {redirect: true, path: "/", to: "/machines", navbarName: "Redirect"}
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx